import { z } from "zod";

import { constantsData } from "@/data";

export const loginFormSchema = z.object({
    password: z.string().min(
        1,
        { message: constantsData.msgs.requiredField },
    ),
    username: z.string().min(
        1,
        { message: constantsData.msgs.requiredField },
    ),
});
